<template>
  <div class="app-right-main">
    <el-row :gutter="20" class="searchRow">
      <el-col :span="22">
        <!-- 查询框区域 -->
        <el-form :model="form" size="mini" :inline="true" label-width="90px">
          <el-form-item label="" prop="id">
            <el-input
              placeholder="请输入单号、用户ID(uuid)、用户昵称搜索"
              clearable
              v-model.trim="form.keyword"
              style="width: 305px"
            ></el-input>
          </el-form-item>
          <el-form-item label="问题类型：" prop="category">
            <el-select
              size="mini"
              collapse-tags
              filterable
              v-model.trim="form.category"
              clearable
            >
              <el-option
                v-for="(item, key) in categoryMap"
                :key="key"
                :label="item"
                :value="key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="ID：" prop="userId">
            <el-input
              placeholder="输入ID进行搜索"
              clearable
              v-model.trim="form.userId"
            ></el-input>
          </el-form-item> -->

          <!-- <el-form-item label="手机号：" prop="mobile">
          <el-input
            placeholder="输入手机号进行搜索"
            clearable
            v-model.trim="form.mobile"
          ></el-input>
        </el-form-item> -->

          <!-- <el-form-item label="反馈内容：" prop="content">
          <el-input
            placeholder="请输入反馈内容进行搜索"
            clearable
            v-model.trim="form.content"
          ></el-input>
        </el-form-item> -->
          <!-- <el-form-item label="邮箱：" prop="email">
          <el-input
            placeholder="输入邮箱进行搜索"
            v-model.trim="form.email"
          ></el-input>
        </el-form-item> -->
          <el-form-item label="创建时间" prop="createTime">
            <el-date-picker
              clearable
              v-model="form.createTime"
              type="daterange"
              :value-format="'yyyy-MM-dd'"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态：" prop="status">
            <el-select
              multiple
              clearable
              collapse-tags
              filterable
              v-model.trim="form.status"
              size="mini"
              placeholder="全部"
            >
              <el-option
                v-for="item in statelist"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="国家：" prop="prefix">
            <el-select
              multiple
              size="mini"
              collapse-tags
              filterable
              v-model.trim="form.prefix"
              clearable
            >
              <el-option
                v-for="item in country"
                :key="item.EnName"
                :label="item.CnName"
                :value="item.Prefix"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="设备：" prop="deviceType">
            <el-select
              multiple
              size="mini"
              collapse-tags
              filterable
              v-model.trim="form.deviceType"
              clearable
            >
              <el-option
                v-for="item in deviceList"
                :key="item.key"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="联系方式" prop="contact">
          <el-input
            placeholder="请输入联系方式进行搜索"
            clearable
            v-model.trim="form.contact"
          ></el-input>
        </el-form-item> -->
        </el-form>
      </el-col>

      <!-- 提交按钮 -->
      <el-col :span="2" class="searchbuttons">
        <div>
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-search"
            @click="onSubmit"
            >查询</el-button
          >
        </div>
        <div class="searchButton">
          <el-button
            type="info"
            size="mini"
            icon="el-icon-refresh-right"
            @click="reset"
            >重置</el-button
          >
        </div>
      </el-col>
    </el-row>

    <el-table
      size="small"
      empty-text="暂无数据"
      :data="tableData"
      v-loading="loading"
      style="width: 100%"
      @sort-change="sortFn"
      :default-sort="{ prop: 'CreateTime', order: 'descending' }"
    >
      <el-table-column align="left" label="编号" type="index" width="60">
        <template slot-scope="scope">
          {{ scope.row.id || "-" }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="用户名称">
        <template slot-scope="scope">
          {{ scope.row.RealName || "-" }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="用户ID">
        <template slot-scope="scope">
          <div
            v-if="scope.row.UserId > 0"
            @click="toUserDetail(scope)"
            style="color: #165dff; cursor: pointer"
          >
            {{ scope.row.UserId || "-" }}
          </div>
          <!-- <router-link
            v-if="scope.row.UserId > 0"
            target="_blank"
            :to="{
              path: '/userDetail',
              query: {
                id: scope.row.UserId,
                tabs: 'first',
              },
            }"
          >
            {{ scope.row.UserId || "-" }}
          </router-link> -->
          <span v-if="scope.row.UserId <= 0">
            {{ scope.row.Uuid || "-" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="问题类型">
        <template slot-scope="scope">
          {{ categoryMap[scope.row.Category] || categoryMap[0] }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="反馈内容" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.Content || "-" }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="图片" width="200">
        <template slot-scope="scope">
          <el-row :gutter="6">
            <el-col
              :span="6"
              :key="index"
              v-for="(item, index) in scope.row.Urls"
            >
              <el-image
                style="width: 40px"
                :src="item"
                :preview-src-list="[item]"
              >
              </el-image>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column align="left" label="联系方式">
        <template slot-scope="scope">
          {{ scope.row.Contact || "-" }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="绑定设备" width="160">
        <template slot-scope="scope">
          <el-row :gutter="6" v-if="scope.row.DeviceType">
            <el-col
              :span="8"
              :key="index"
              v-for="(item, index) in scope.row.DeviceType.split(',')"
            >
              <device-image
                :name="item"
                :width="40"
                :height="40"
              ></device-image>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column align="left" label="国家">
        <template slot-scope="scope">
          {{ scope.row.Country || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        prop="CreateTime"
        sortable="custom"
        min-width="100"
        label="创建时间"
      >
        <template slot-scope="scope">
          <span> {{ scope.row.CreateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        min-width="100"
        label="最新回复时间"
        prop="LastModifyTime"
      >
        <template slot-scope="scope">
          {{ scope.row.LastModifyTime }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="状态">
        <template slot-scope="scope">
          {{
            scope.row.Status == 2
              ? "已完成"
              : scope.row.Status == 1
              ? "进行中"
              : "未处理"
          }}
        </template>
      </el-table-column>
      <el-table-column align="left" width="100" fixed="right" label="操作">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="消息回复"
            placement="bottom"
          >
            <el-button
              v-permission="'message_reply'"
              type="text"
              size="small"
              class="el-icon-chat-line-round"
              @click.native.prevent="messageHide(scope.row)"
            >
              <!-- 消息回复 -->
            </el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="状态更新"
            placement="bottom"
          >
            <el-button
              type="text"
              size="small"
              v-permission="'state_change'"
              class="el-icon-edit"
              @click.native.prevent="resetStatus(scope.row)"
            >
              <!-- 状态更新 -->
            </el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="详情"
            placement="bottom"
          >
            <router-link
              :to="{
                path: '/feedbackDetail',
                query: {
                  id: scope.row.id,
                },
              }"
            >
              <el-button type="text" size="small" class="el-icon-view ml10">
                <!-- 详情 -->
              </el-button>
            </router-link>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="dial-pagination">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="size"
        layout="->,total, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-drawer
      title="消息回复"
      :size="650"
      :visible.sync="drawer"
      :direction="direction"
      :wrapperClosable="false"
      :before-close="handleClose"
    >
      <ReplyMessage
        :feedbackId="feedbackId"
        :UpdateStateData="UpdateStateData"
        ref="ReplyMessage"
      />
    </el-drawer>
    <UpdateState
      :UpdateStateData="UpdateStateData"
      :pwdDialogVisible.sync="pwdDialogVisible"
      :statusFormCurrentState.sync="statusFormCurrentState"
      @changFeedback="changFeedback"
      ref="UpdateState"
    />
  </div>
</template>

<script>
import {
  feedbacks,
  feedbackdelete,
  requestListCountries,
} from "../../api/userApi";

import { handleResponse } from "@/utils/response";
// import { dateFormat } from "../../utils/util";
// import ResetStatusForm from "./resetStatusForm";
import ReplyMessage from "./ReplyMessage";
import UpdateState from "./UpdateState";

import DeviceImage from "./../deviceImage";

export default {
  name: "Feedback",
  components: {
    // ResetStatusForm,
    ReplyMessage,
    UpdateState,
    DeviceImage,
  },
  created() {
    var params = this.params();
    this.getFeedbacks(params);
    this.requestListCountriesfn();
  },
  activated() {
    var params = this.params();
    this.getFeedbacks(params);
    this.requestListCountriesfn();
  },
  computed: {
    editFlag() {
      //修改用户反馈权限控制
      return (
        this.$store.state.userInfo.permissions.includes("updateFeedback") ||
        this.$store.getters.isAdmin
      );
    },
  },

  methods: {
    toUserDetail(scope) {
      if (this.$jumpPerm("user_detail")) {
        this.$router.push({
          path: "/userDetail",
          query: {
            id: scope.row.UserId,
            tabs: "first",
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    sortFn({ order }) {
      if (order == "ascending") {
        this.sort = 1;
      } else if (order == "descending") {
        this.sort = -1;
      } else {
        this.sort = null;
      }
      var params = this.params();
      this.getFeedbacks(params);
    },
    changFeedback() {
      var params = this.params();
      this.getFeedbacks(params);
    },
    pwdDialogVisibleChange(pwdDialogVisible) {
      this.pwdDialogVisible = pwdDialogVisible;
    },
    handleClose() {
      this.drawer = false;
      this.$refs.ReplyMessage.initMessage();
    },
    messageHide(row) {
      this.feedbackId = row.id;
      this.drawer = true;
      this.UpdateStateData = row;
      this.$nextTick(() => {
        this.$refs.ReplyMessage.addMessage();
      });
    },
    reset() {
      for (let key in this.form) {
        this.$delete(this.form, key);
      }
      this.onSubmit();
    },
    async requestListCountriesfn() {
      var countriesList = await requestListCountries();
      this.country = countriesList.data.data.result;
    },
    params() {
      let params = {
        ...this.form,
      };
      for (let key in params) {
        if (Array.isArray(params[key])) {
          params[key] = params[key].join(",");
        }
        if (!params[key]) {
          delete params[key];
        }
      }
      params = {
        page: this.page,
        size: this.size,
        sort: this.sort,
        ...params,
      };

      return params;
    },
    getFeedbacks(params) {
      this.loading = true;
      feedbacks(params).then((response) => {
        handleResponse(
          response,
          (data) => {
            this.tableData = data.list;
            this.total = data.count;
            // this.total = data.total * data.size; // total是页数;
            this.loading = false;
          },
          (error) => {
            this.loading = false;
          }
        );
      });
    },

    handleCurrentChange(val) {
      this.page = val;
      var params = this.params();
      this.getFeedbacks(params);
    },
    delinfo(row) {
      //删除反馈信息
      this.$confirm("您确定要删除该反馈吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          var res = await feedbackdelete({
            id: row.id,
          });
          if (res.data.data && res.data.data.result) {
            var params = this.params();
            this.getFeedbacks(params);
            this.$message({
              type: "success",
              message: "删除成功",
            });
          } else {
            this.$message({
              type: "info",
              message: "删除失败",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "info",
            message: "删除失败",
          });
        });
    },
    resetStatus(row) {
      this.statusFormCurrentState = row.Status;
      this.pwdDialogVisible = true;
      this.UpdateStateData = row;
      this.$refs.UpdateState.initStatusForm();
    },

    confirmPwdAction() {
      var params = this.params();
      this.getFeedbacks(params);
    },
    onSubmit() {
      this.page = 1;
      var params = this.params();
      this.getFeedbacks(params);
    },
    cancel() {
      window.reload();
    },
  },
  data() {
    return {
      sort: -1,
      UpdateStateData: {},
      TypeIds: [],
      feedbackId: 0,
      statusFormCurrentState: 0,
      userName: "",
      direction: "rtl",
      country: [],
      loading: false,
      tableData: [],
      size: 20,
      page: 1,
      total: 0,
      drawer: false,
      pwdDialogVisible: false,
      pwdForm: {},
      form: {},
      searchValFormat: "yyyy-MM-dd",
      statelist: [
        {
          value: "0",
          label: "未处理",
        },
        {
          value: "1",
          label: "进行中",
        },
        {
          value: "2",
          label: "已完成",
        },
      ],
      categoryMap: {
        1: "APP故障",
        2: "设备故障",
        3: "意见建议",
        0: "其他",
      },
      deviceList: [
        {
          key: 1,
          value: "Y001S",
          label: "Y001S",
        },
        {
          key: 2,
          value: "Y006",
          label: "Y006",
        },
        {
          key: 3,
          value: "Y007",
          label: "Y007",
        },
        {
          key: 0,
          value: "未绑定",
          label: "未绑定设备",
        },
      ],
    };
  },
};
</script>

<style lang="less">
.el-tooltip__popper.is-dark {
  z-index: 6 !important;
}
.el-select,
.el-cascader {
  width: 100%;
  padding-right: 20px;
}
// .is-justify-end{
//   display: flex;
//   justify-content: end;
//   padding-right: 3%;
//   padding-bottom: 50px;
// }
.el-drawer__header {
  margin: 0 !important;
  padding: 10px 20px !important;
  color: #333;
}
.ml10 {
  margin-left: 10px !important;
}
.el-table__cell {
  .el-button::before {
    font-size: 20px;
  }
}
.app-right-main {
  padding-top: 20px;
  form {
    padding: 0 20px;
  }
}
</style>
